<template>
  <section>
    <div class="sonAccount">
      <div class="title">发票管理</div>
      <div class="pad10">
        <el-button type="primary" @click="handleEdit">新增发票</el-button>
      </div>
      <el-table
        :data="accountList.data"
        style="width: 100%"
       
      >
          <el-table-column fixed prop="" label="选择发票"  width="100">
            <template slot-scope="scope">
             <el-checkbox v-model="scope.row.checked" @change="invoicecheckbox(scope.row.checked,scope.row.id)"></el-checkbox>
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column fixed prop="title" label="单位名称"></el-table-column>
        <el-table-column fixed prop="address" label="单位地址"></el-table-column>
        <el-table-column fixed prop="telephone" label="单位电话"></el-table-column>
        <el-table-column fixed prop="bank" label="开户行"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
        <el-table-column prop="taxno" label="纳税人识别号"></el-table-column>
        <el-table-column label="操作" width='170'>
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <!-- <el-button
              size="mini"
              type="primary"
              @click="shouxin(scope.row.companyid)"
              class="shouxin"
            >授信</el-button>-->
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="accountList.per_page"
        @current-change="currentorder"
        :total="accountList.total"
      ></el-pagination>
    </div>
    <!-- 对话框 -->
    <el-dialog
      title
      :visible.sync="centerDialogVisible"
      width="60%"
      center
      class="invoiceDialog"
      @close="closeDialog"
    >
      <div class="jiesuanbox">
        <div class="ordertotal flex">
          <el-tabs v-model="isinvoice" type="border-card" class="isinvoice" style="width:100%">
            <!-- <el-tab-pane label="不开发票" name="0"></el-tab-pane> -->
            <el-tab-pane label="发票管理" name="1">
              <div class="form" style="margin-top:20px;">
                <el-form
                  :model="invoiceRuleForm1"
                  :rules="rules1"
                  ref="invoiceRuleForm1"
                  label-width="120px"
                  class="demo-ruleForm"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="单位名称" prop="title">
                        <el-input v-model="invoiceRuleForm1.title"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="单位地址">
                        <el-input v-model="invoiceRuleForm1.address"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="单位电话">
                        <el-input v-model="invoiceRuleForm1.telephone"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开户行">
                        <el-input v-model="invoiceRuleForm1.bank"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="账号">
                        <el-input v-model="invoiceRuleForm1.account"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="纳税人识别码" prop="taxno">
                        <el-input v-model="invoiceRuleForm1.taxno"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="备注">
                        <el-input v-model="invoiceRuleForm1.remark"></el-input>
                      </el-form-item>
                    </el-col>
                   
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="增值税发票" name="2">
              <div class="form" style="margin-top:20px;">
                <el-form
                  :model="invoiceRuleForm2"
                  :rules="rules2"
                  ref="invoiceRuleForm2"
                  label-width="120px"
                  class="demo-ruleForm"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="单位名称" prop="title">
                        <el-input v-model="invoiceRuleForm2.title"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="单位地址" prop="address">
                        <el-input v-model="invoiceRuleForm2.address"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="单位电话" prop="telephone">
                        <el-input v-model="invoiceRuleForm2.telephone"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="开户行" prop="bank">
                        <el-input v-model="invoiceRuleForm2.bank"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="账号" prop="account">
                        <el-input v-model="invoiceRuleForm2.account"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="纳税人识别码" prop="taxno">
                        <el-input v-model="invoiceRuleForm2.taxno"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="备注">
                        <el-input v-model="invoiceRuleForm2.remark"></el-input>
                      </el-form-item>
                    </el-col>
                   
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 授信 -->
    <el-dialog
      title="授信"
      :visible.sync="shouxindialogFormVisible"
      width="30%"
      :before-close="closeshouxin"
    >
      <el-form :model="setauth">
        <el-form-item label="授信金额">
          <el-input v-model="setauth.authmoney" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="账单日">
          <el-select v-model="setauth.authdate" placeholder="请选择账单日" style="width:100%">
            <el-option :label="item" :value="item" v-for="(item,index) in 28" :key="index"></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shouxindialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="shopSetauth">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "Order",
  data() {
    return {
      page: 1,
      shouxindialogFormVisible: false,
      isinvoice: "1",
      invoiceid:"",
      companyid: "",
      setauth: {
        authmoney: "",
        authdate: ""
      },
      invoiceRuleForm2: {
        title: "",
        address: "",
        telephone: "",
        bank: "",
        account: "",
        remark:"",
        taxno: ""
      },
      invoiceRuleForm1: {
        title: "",
        address: "",
        telephone: "",
        bank: "",
        account: "",
        remark:"",
        taxno: ""
      },
      multipleSelection: [],
      rules2: {
        title: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        telephone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        taxno: [
          { required: true, message: "请输入纳税人识别码", trigger: "blur" }
        ]
      },
      rules1: {
        title: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],

        taxno: [
          { required: true, message: "请输入纳税人识别码", trigger: "blur" }
        ]
      },
      accountList: [], //发票列表
      departmentList: [], //部门列表

      centerDialogVisible: false
    };
  },
  props: {},
  methods: {
    handleEdit(row) {
      //编辑
      this.centerDialogVisible = true;
      if (row.title) {
        setTimeout(() => {
          for (let key in this.invoiceRuleForm1) {
            this.invoiceRuleForm1[key] = row[key];
            console.log("编辑", row[key]);
          }
          this.invoiceRuleForm1["id"] = row.id;
          // console.log("编辑", row);
        }, 500);
      }
    },
    handleSelectionChange(val) {
      //  console.log(this.multipleSelection.length,val)
      // this.multipleSelection = val;
      console.log(val)
      // for (let i = 0; i < val.length; i++) {
      //   if (this.multipleSelection.length > 0) {
      //     if (val[i].id == this.multipleSelection[i].id) {
      //       val.splice(i, 1);
      //     }
      //   }
      // }
      console.log(val);
      // this.multipleSelection=val
    },
    submitInvoice() {},
    async shopSetauth() {
      if (!this.setauth.authdate || !this.setauth.authmoney) {
        this.$message.error("请填写完整信息");
        return;
      }
      let res = await this.$fetch("shop/setauth", {
        body: {
          companyid: this.companyid,
          authdate: this.setauth.authdate,
          authmoney: this.setauth.authmoney
        }
      });
      this.shouxindialogFormVisible = false;
      this.getaccountList();
    },
    closeshouxin() {
      this.setauth.authdate = "";
      this.setauth.authmoney = "";
    },
    // 给发票授信弹框
    async shouxin(companyid) {
      this.shouxindialogFormVisible = true;
      this.companyid = companyid;
      return;
      this.$prompt("请填写授信", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
        inputErrorMessage: "请输入正确的授信数字"
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "输入的授信是: " + value
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '取消输入'
          // });
        });
    },
    async handleDelete(id) {
      //删除发票
      let that = this;
      this.$confirm("此操作将删除该数据, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await that.$fetch("Member/invoice", {
            body: { act: "delete", data: { id } }
          });
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.getaccountList();
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs[`invoiceRuleForm${this.isinvoice}`].validate(async valid => {
        if (valid) {
          console.log("验证成功", this[`invoiceRuleForm${this.isinvoice}`]);

          let res = await this.$fetch("Member/invoice", {
            body: {
              act: "save",
              data: this[`invoiceRuleForm${this.isinvoice}`]
            }
          });
          if (res) {
            this.$message({ type: "success", message: "提交成功" });
            this.centerDialogVisible = false;
            this.getaccountList();
          }
        } else {
          console.log("验证不成功");
          return;
        }
      });
    },
    invoicecheckbox(checked,id){
      let accountList=this.accountList;
      // let ischecked=false;
       for(let i=0;i<accountList.data.length;i++){
        accountList.data[i]['checked']=false;
        if(accountList.data[i].id==id){
           console.log("发票列表", checked);
           accountList.data[i]['checked']=checked;
          //  this.invoiceid=id;
          //  ischecked=true;
        }
      }
      // if(!ischecked) this.invoiceid='';
     
      this.accountList = accountList;
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      for (let key in this.invoiceRuleForm1) {
        this.invoiceRuleForm1[key] = "";
      }
    },

    closeDialog() {
      // 关闭对话框回调
      this.resetForm("invoiceRuleForm1");
    },
    currentorder(e) {
      this.page = e;
    },

    async getaccountList() {
      // 发票列表
      let accountList = await this.$fetch("member/invoice", {
        body: {
          act: "list",
          page: 1,
          size: 50
        }
      });
      for(let i=0;i<accountList.data.length;i++){
        accountList.data[i]['checked']=false;
      }
      console.log("发票列表", accountList);
      this.accountList = accountList;
    }
  },
  mounted() {
    this.getaccountList(); // 发票列表
  }
};
</script>

<style lang='scss' scoped>
.layui-unselect {
  display: none !important;
}

.zhizhao {
  img {
    width: 130px;
    height: 70px;
    background: rgba(245, 245, 246, 1);
    border-radius: 0%;
  }
}
.row {
  .layui-form-checkbox {
    display: none;
  }
}
.shouxin {
  margin: 5px 0;
}
.tac .is-active {
  color: #f19d15 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice.vue